import React, { useEffect, useState } from "react";
import AllergyDetails from "./AllergyDetails";
import ChronicCondition from "./ChronicCondition";
import FamilyHistory from "./FamilyHistory";
import Vitals from "./Vitals";
import HealthTrends from "./HealthTrends";
import SocialHistory from "./SocialHistory";
import PastMedicalHistory from "./PastMedicalHistory";
import SurgicalHistory from "./SurgicalHistory";
import Medication from "./Medication";
import Immunization from "./Immunization";
import EmergencyCard from "./EmergencyCard";
import { useLocation, useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";
import Prescription from "./Prescription";
import UploadReport from "./UploadReport";

const TABS = [
  { label: "Medical History", value: "Medical History" },
  { label: "Prescription",    value: "Prescription"    },
  { label: "Uploaded Report", value: "Report"          },
];

function HealthSummary() {
  const loggedUserJson = localStorage.getItem("patientData");
  const loggedUser = loggedUserJson ? JSON.parse(loggedUserJson) : null;
  const { state } = useLocation();
  const [selectedPatient, setSelectedPatient] = useState(null);
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState("Medical History");

  useEffect(() => {
    if (!state) {
      navigate(APP_ROUTES.LOGIN);
    } else {
      setSelectedPatient(state?.patientId);
    }
  }, [state]);

  const handleOptionChange = (option) => setSelectedOption(option);

  const handleBack = () => {
    navigate(state?.path || "/");
  };

  return (
    <>
      <style>{`
        /* ── Pill toggle ── */
        .hs-tabs {
          display: flex;
          align-items: stretch;
          background: #fff;
          border-radius: 9999px;
          border: 1.5px solid #e5e7eb;
          padding: 4px;
          gap: 4px;
          width: 95%;
          margin: 12px auto 0;
          box-sizing: border-box;
        }

        .hs-tab-btn {
          flex: 1;
          border: none;
          border-radius: 9999px;
          cursor: pointer;
          font-weight: 600;
          line-height: 1.25;
          text-align: center;
          transition: background 0.22s, color 0.22s, box-shadow 0.22s;
          background: transparent;
          color: #4b5563;
          /* fluid font: 11 px on ~320 px screens, 14 px on ≥480 px */
          font-size: clamp(11px, 3vw, 14px);
          /* fluid vertical padding */
          padding: clamp(6px, 1.8vw, 10px) clamp(4px, 1.2vw, 8px);
          white-space: normal;
          word-break: break-word;
        }

        .hs-tab-btn.active {
          background: #0AA0AC;   /* matches secondaryColor */
          color: #fff;
          box-shadow: 0 2px 8px rgba(10, 160, 172, 0.30);
        }

        .hs-tab-btn:not(.active):hover {
          background: #f0fafb;
          color: #0AA0AC;
        }
      `}</style>

      <div className="w-full overflow-y-scroll h-screen bg-cover bg-center bg-fixed bg-blue-50">
        {/* Header */}
        <div className="bg-secondaryColor mb-2">
          <div className="flex justify-between p-3">
            <h2 className="font-bold text-xl sm:text-sm text-white">Health Summary</h2>
            {loggedUser && (
              <h2
                className="font-bold text-xl sm:text-sm cursor-pointer text-white"
                onClick={handleBack}
              >
                {`← Back`}
              </h2>
            )}
          </div>
        </div>

        {/* ── Responsive pill toggle ── */}
        <div className="hs-tabs">
          {TABS.map((tab) => (
            <button
              key={tab.value}
              className={`hs-tab-btn${selectedOption === tab.value ? " active" : ""}`}
              onClick={() => handleOptionChange(tab.value)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="w-[95%] m-auto mt-5">
          {selectedOption === "Medical History" && selectedPatient && (
            <div className="grid grid-cols-4 sm:grid-cols-1 md:grid-cols-2 border rounded-lg gap-4 bg-blue-100">
              <AllergyDetails selectedPatient={selectedPatient} />
              <PastMedicalHistory selectedPatient={selectedPatient} />
              <Immunization selectedPatient={selectedPatient} />
              <FamilyHistory selectedPatient={selectedPatient} />
              <SocialHistory selectedPatient={selectedPatient} />
              <Medication selectedPatient={selectedPatient} />
              <SurgicalHistory selectedPatient={selectedPatient} />
              <ChronicCondition selectedPatient={selectedPatient} />
              <Vitals selectedPatient={selectedPatient} />
              <HealthTrends selectedPatient={selectedPatient} />
              <EmergencyCard selectedPatient={selectedPatient} />
            </div>
          )}

          {selectedOption === "Prescription" && selectedPatient && (
            <div className="grid border rounded-lg">
              <Prescription selectedPatient={selectedPatient} />
            </div>
          )}

          {selectedOption === "Report" && selectedPatient && (
            <div className="grid border rounded-lg">
              <UploadReport selectedPatient={selectedPatient} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default HealthSummary;
